// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import PollingController from "./polling_controller"
application.register("polling", PollingController)

import AnalyzeController from "./analyze_controller"
application.register("analyze", AnalyzeController)

import GenerateController from "./generate_controller"
application.register("generate", GenerateController)

import OptionsEditorController from "./options_editor_controller"
application.register("options-editor", OptionsEditorController)

import EvidenceController from "./evidence_controller"
application.register("evidence", EvidenceController)

import AutohideController from "./autohide_controller"
application.register("autohide", AutohideController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import ReportController from "./report_controller"
application.register("toc", ReportController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import CookieConsentController from "./cookie_consent_controller"
application.register("cookie-consent", CookieConsentController)

import SurveyTabsController from "./survey_tabs_controller"
application.register("survey-tabs", SurveyTabsController)

import WatercolorController from "./watercolor_controller"
application.register("watercolor", WatercolorController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import PricingToggleController from "./pricing_toggle_controller"
application.register("pricing-toggle", PricingToggleController)

import QrModalController from "./qr_modal_controller"
application.register("qr-modal", QrModalController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import BrandColorController from "./brand_color_controller"
application.register("brand-color", BrandColorController)

import CopyButtonController from "./copy_button_controller"
application.register("copy-button", CopyButtonController)

import AppearanceThemeController from "./appearance_theme_controller"
application.register("appearance-theme", AppearanceThemeController)

import ContactToggleController from "./contact_toggle_controller"
application.register("contact-toggle", ContactToggleController)